const escapeRegExp = (value) => {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

const formatWorkOrderSearch = (input) => {
  const woSearchText = Number(input).toString();
  const cleanWoSearchRegex = new RegExp(escapeRegExp(woSearchText), 'i');
  return cleanWoSearchRegex;
};

export { formatWorkOrderSearch };